module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-relax-btn-riben.3d391702.png";